import type { NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { type ControlInterface, enumValidator } from '@comparit/core';
import { Gebaeudetyp, type Step3FormInput } from '../../../interfaces';

export class Step3Form {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: Step3FormInput | null
  ) {}

  ctrls: ControlInterface<Step3FormInput> = {
    gebaeudetyp: this.fb.control<Gebaeudetyp>(
      this.defaultValue?.gebaeudetyp ?? Gebaeudetyp.Einfamilienhaus,
      // The cards can only set a valid Gebäudetyp, so enumValidator is what catches a stale value
      // restored from storage.
      [Validators.required, enumValidator(Gebaeudetyp)]
    ),
  };

  public fg = this.fb.group(this.ctrls);
}
